import React, { useState } from 'react';
import { Activity } from 'lucide-react';
import type { DeviceHealthDeviceStat } from '@platform/shared-types';
import DeviceHealthPanel from '../../components/deviceHealth/DeviceHealthPanel';
import BrandingTab from '../pos/branding/BrandingTab';
import { InventoryPage } from '../inventory/InventoryChrome';
import { DeviceLinkBase, FLEET_MONITORING_DEVICE_BASE } from '../pos/device/deviceLinkBase';

/**
 * FLEET MONITORING (spec §9, owner 2026-10-04; redesign approved 2026-10-06 —
 * docs/mockups/fleet-monitoring-redesign-mockup.html, screen 1).
 *
 * Top: fleet health as ONE thin strip of stat tiles, with the chart, worst
 * stores, top problems and worst devices collapsed behind "Health details"
 * (remembered per browser) so the device list starts high on the page.
 * Below: the compact fleet list (`FleetList`, via BrandingTab layout
 * "monitoring") — six facts per till, whole row opens the device page at
 * /fleet-monitoring/devices/:id. No side drawer and no row actions here; they
 * live on the device page. POS Config's Fleet tab keeps the full FleetTable.
 *
 * Section `/fleet-monitoring`: view = panels, edit = fleet actions (which still
 * also need `/pos-config` on the API side). Chrome is the shared black header +
 * ruby underline (InventoryChrome).
 */
export default function FleetMonitoringPage() {
  const [health, setHealth] = useState<Record<string, DeviceHealthDeviceStat> | undefined>(undefined);
  return (
    <InventoryPage
      icon={Activity}
      title="Fleet Monitoring"
      subtitle="Every till, what it's running, and whether it needs you."
      crumb="Deployment & Release"
      wide
    >
      {/* Device links on this page open /fleet-monitoring/devices/:id directly. */}
      <DeviceLinkBase.Provider value={FLEET_MONITORING_DEVICE_BASE}>
        <div className="mx-auto max-w-[1440px] space-y-4">
          <DeviceHealthPanel scope="fleet" collapsible onSummary={(s) => setHealth(s.devices)} />
          <BrandingTab tab="fleet" layout="monitoring" health={health} />
        </div>
      </DeviceLinkBase.Provider>
    </InventoryPage>
  );
}
